<template>
    <div class="setting-box">
        <div class="setting-title">选项设置</div>
        <div class="setting-content">
            <div class="setting-content-item item-row">
                <span>选项类型</span>
                <el-radio-group v-model="dataList.scoreType" class="ml-4" @change="typeChange">
                    <el-radio :label="1" size="large">单项</el-radio>
                    <el-radio :label="2" size="large">多项</el-radio>
                </el-radio-group>
            </div>
            <div class="setting-content-item item-row">
                <span>样式</span>
                <div class="select-box">
                    <el-select ref="selectRef" v-model="dataList.icon" class="m-2" placeholder="Select" size="large">
                        <el-option v-for="item in iconOptions" :key="item.value" :label="item.label" :value="item.value">
                            <div style="margin-top: 5px">
                                <score-number v-if="item.value === 'Number'" :iconType="item.value" />
                                <score-number-s v-else-if="item.value === 'NumberS'" :iconType="dataList.icon" />
                                <score-ruler style="margin-top: 15px" v-else-if="item.value === 'Ruler'" :iconType="item.value" />
                                <score-icon v-else :iconType="item.value" />
                            </div>
                        </el-option>
                    </el-select>
                    <div class="chose-icon">
                        <score-number v-if="dataList.icon === 'Number'" :iconType="dataList.icon" />
                        <score-number-s v-else-if="dataList.icon === 'NumberS'" :iconType="dataList.icon" />
                        <score-ruler v-else-if="dataList.icon === 'Ruler'" :iconType="dataList.icon" />
                        <score-icon v-else :iconType="dataList.icon" />
                    </div>
                </div>
            </div>
            <div class="setting-content-item item-row">
                <span>分值</span>
                <div class="select-box">
                    <el-select v-model="dataList.score" class="m-2" placeholder="Select" size="large">
                        <el-option v-for="item in scoreOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="setting-content-item item-row">
                <span>显示分值说明</span>
                <el-switch
                    v-model="dataList.showScoreExplain"
                    class="ml-2"
                    style="--el-switch-on-color: rgba(34, 64, 195, 1); --el-switch-off-color: #d8d8d8"
                />
            </div>
            <div class="setting-content-item" v-show="dataList.showScoreExplain">
                <span>分值说明</span>
                <div class="item-row">
                    <span>最低分</span>
                    <div class="select-box">
                        <el-input v-model="dataList.miniScoreExplain"></el-input>
                    </div>
                </div>
                <div class="item-row">
                    <span>最高分</span>
                    <div class="select-box">
                        <el-input class="score-input" v-model="dataList.maxScoreExplain"></el-input>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup name="kr-score-setting">
import ScoreIcon from "@/components/scoreIcon/Icon.vue";
import ScoreNumber from "@/components/scoreIcon/Number.vue";
import ScoreNumberS from "@/components/scoreIcon/NumberS.vue";
import ScoreRuler from "@/components/scoreIcon/Ruler.vue";

const props = defineProps({
    dataList: {
        type: Object,
        default: () => ({}),
    },
});

let scoreOptions = [
    { label: "5", value: 5 },
    { label: "10", value: 10, icon: "" },
];
let iconOptions = [
    { label: "Star", value: "Star", icon: "" },
    { label: "Thumbs", value: "Thumbs", icon: "" },
    { label: "Smile", value: "Smile", icon: "" },
    { label: "Love", value: "Love", icon: "" },
    { label: "Number", value: "Number", icon: "" },
    { label: "Number", value: "NumberS", icon: "" },
    { label: "Ruler", value: "Ruler", icon: "" },
];
function typeChange(e) {
    // 为1 展示请打分， 为2 展示请给以下各项打分，仅仅在未填写的情况下
    if (e === 1) {
        props.dataList.title = "请打分";
    } else {
        props.dataList.title = "请给以下各项打分";
    }
}
</script>
<style lang="scss" scoped>
@import "@/css/setting.scss";
.item-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
        flex-shrink: 0;
    }
}
.select-box {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    margin-left: 6px;

    .chose-icon {
        position: absolute;
        top: 50%;
        left: 12px;
        transform: translateY(-50%);
        height: 30px;
        background-color: #fff;
        display: flex;
        align-items: center;
        pointer-events: none;
    }
}
:deep(.score-input.el-input),
:deep(.el-select--large) {
    width: 100%;
}

:deep(.el-select-dropdown__item) {
    line-height: 44px;
}
</style>
